import { render, staticRenderFns } from "./ActionBadgeDropdown.vue?vue&type=template&id=50971d32&"
import script from "./ActionBadgeDropdown.vue?vue&type=script&lang=js&"
export * from "./ActionBadgeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports